import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

export const ResponsiveComponent = ({ children, pivot }) => {
  const ref = useRef()
  const [isResponsive, setIsResponsive] = useState(false)

  useEffect(() => {
    const resize = () => {
      const isNewResponsive = ref.current?.getBoundingClientRect().width < pivot
      if (isNewResponsive !== isResponsive) {
        setIsResponsive(isNewResponsive)
      }
    }

    resize()

    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <div className="w100" ref={ref}>
      {children(isResponsive)}
    </div>
  )
}

ResponsiveComponent.propTypes = {
  children: PropTypes.func,
  pivot: PropTypes.number,
}

ResponsiveComponent.defaultProps = {
  children: () => {},
  pivot: 1200,
}
